<template>
  <v-dialog persistent :value="addResources" :width="'850'">
    <v-card>
      <popup-heading 
      title="ADD RESOURCES" 
      subtitle="Resources list">
        <template slot="action">
          <v-btn
            depressed
            @click="closeModal()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
          >
            <v-icon dark class="primary--text">close</v-icon>
          </v-btn>
          <v-btn
            depressed
            @click="addResourcesSubmit()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
          >
            <v-icon dark class="primary--text">check</v-icon>
          </v-btn>
        </template>
      </popup-heading>
      <v-card-text class="pop-header-fixed-content popup-height">
        
        <v-form ref="addForm" lazy-validation>
          <table class="resource-table" width="100%">
            <tr v-bind:key="'resource' + index " v-for="(resource, index) in form.app_resources">
              <td>
                <v-text-field
                  class=""
                  v-model="resource.name"
                  label="Name"
                  :rules="fieldRequired"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  class=""
                  v-model="resource.display_name"
                  label="Display name"
                  :rules="fieldRequired"
                ></v-text-field>
              </td>
              <td width="150px">
                <v-text-field
                  class=""
                  v-model="resource.path"
                  label="Path (optional)"
                ></v-text-field>
              </td>
              <td width="200px">
                <v-select
                  item-text="display_name"
                  item-value="id"
                  :items="availableAppResources"
                  v-model="resource.parent_resource"
                  label="Parent Resource"
                ></v-select>
              </td>
              <td width="50px;" class="text-xs-right">
                <v-btn
                  @click="removeObj(index)"
                  fab 
                  small
                  dark 
                  color="primary"
                  :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2 xs-small' : 'ml-3 xs-small'"
                >
                  <v-icon dark>fas fa-minus</v-icon>
                </v-btn>
              </td>
            </tr>
          </table>
        </v-form>

        <div class="py-2 text-xs-right">
          <v-btn
            @click="addNewObj()"
            fab    
            dark 
            color="primary"
          >
            <v-icon dark>add</v-icon>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { some, isEmpty } from 'lodash';

export default {

  data() {
    return {
      urlValidation: [
        v => !!v || 'Field is required',
        v =>
          /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(v) || 'Invalid url',
      ],
      fieldRequired: [
        v => !!v || 'Field is required.',
      ],
     
      form:{
        app_resources: [
        ],
      },
      availableAppResources: [],
    };
  },
  computed: {
   
    ...mapGetters({
      addResources: 'superadminapps/addResources',
      addResourcesObj: 'superadminapps/addResourcesObj',
    }),

  },
  watch: {
    'addResourcesObj': function(val){
      if(!_.isEmpty(val)){
        // Fetch all resources for app
        this.fetchAllResourcesForApp(val.id);
        this.addNewObj();
      }
    }
  },
  created() {
    this.closeModal();
  },
 
  methods: {
    
    /**
     * Add new object
     */
    addNewObj() {
      this.form.app_resources.push({
        name: '',
        display_name: '',
        path: '',
        parent_resource: '',
        parent_resource: '',
      });
    },
    /**
     * Remove obj
     */

    removeObj(index) {
       this.form.app_resources.splice(index, 1);
    },
    
    /**
     * Fetch all resources  for an app
     */
    fetchAllResourcesForApp(appId) {
      this.spinner(true);
      const url = `${Env.url}/api/v1/apps/${appId}/resources`;
      AuthApi.getApi(url, this.form)
        .then((res) => {
          this.spinner(false);
         // this.availableAppresources = res.data.payload;
          let data = [];
          let rawData = res.data.payload;
          rawData.map(item => {
           
            data.push({
              id: item.id,
              display_name: item.display_name ? item.display_name : item.name,
              name: item.name,
            });
            // Child
            if(item.hasOwnProperty('sub_resources')){
              let childRawData =  item.sub_resources;
              childRawData.map(childItem => {
                data.push({
                  id: childItem.id,
                  display_name: childItem.display_name ? childItem.display_name : childItem.name,
                  name: childItem.name,
                });

                 // Grand child  
                  if(childRawData.hasOwnProperty('sub_resources')){
                    let grandChildRawData  = childItem.sub_resources;
                    grandChildRawData.map(grandChildItem => {
                      data.push({
                        id: grandChildItem.id,
                        display_name: grandChildItem.display_name ? grandChildItem.display_name : grandChildItem.name,
                        name: grandChildItem.name,
                      });
                    });
                  }
              });
            }
          });

          this.availableAppResources = data;
        })
        .catch(() => {
        this.spinner(false);
          console.log('Unable to fetch resource for the app');
        });
    },

    /**
     * Add resources 
     */
      addResourcesSubmit() {
        if (this.$refs.addForm.validate()) {
          this.spinner(true);
          const url = `${Env.url}/api/v1/apps/${this.addResourcesObj.id}/resources/bulk`;
          AuthApi.postApi(url, this.form) 
          .then((res) => {
            this.spinner(false);
            this.snackbar({
              text: res.data.msg,
              timeout: 4000,
              open: true,
            });
            this.closeModal();
          })
          .catch(err => {
            this.spinner(false);
            this.snackbar({
              text: err.response.data.msg,
              timeout: 4000,
              open: true,
            });
          })
        }
      },

    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      this.setaddResources(false);
      this.setaddResourcesObj({});
      this.form.app_resources = [];
      this.availableAppResources = [];
    },

    ...mapActions({
      setaddResources: 'superadminapps/setAddResources',
      setaddResourcesObj: 'superadminapps/setAddResourcesObj',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>

